export default __webpack_public_path__ + "static/media/load-green.27f6c021.gif";